import { CSSProperties } from "react";

const useDefaultDisabledStyles = () => {
  return { defaultDisabledStyles: { pointerEvents: "none", opacity: 0.5 } as CSSProperties };
};

export default useDefaultDisabledStyles;
